// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__rdOvl","saveButton":"style_saveButton__vB5sL","saveButtonText":"style_saveButtonText__2U5Y5"};